import { SERVER_ROUTES, QUERY_KEYS } from "@constants/api.routes";
import type { UpdateProfilePayload } from "../../types";
import { authApi } from "@config/axios/axios.config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_STATUS } from "@constants/http.status.code";
import { showNotification } from "@libs/notistack/notificationStack";
import { SNACKBAR_SEVERITY } from "@constants/notificationStack";

interface UpdateProfileApiResponse {
	success: boolean;
	statusCode: number;
	message?: string;
	data?: unknown;
}

export const useUpdateProfile = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (data: UpdateProfilePayload) => {
			// axios interceptor returns response.data directly
			const response = await authApi.put(SERVER_ROUTES.USER.EMPLOYER_UPDATE, data) as UpdateProfileApiResponse;
			console.log("Update profile response:", response);
			return response;
		},
		onSuccess: (response: UpdateProfileApiResponse) => {
			console.log("Update profile success, invalidating profile query");
			
			// Always invalidate profile query to refetch updated data
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER.GET_PROFILE] });
			
			if (response?.statusCode === HTTP_STATUS.OK || response?.statusCode === HTTP_STATUS.CREATED || response?.success) {
				if (response?.message) {
					showNotification({
						message: response.message,
						severity: SNACKBAR_SEVERITY.SUCCESS,
					});
				}
			}
		},
	});
};
